/**
 * className处理
 * @param {*} prefix
 * @returns
 */
export const cls = prefix => {
  // @ts-ignore
  return (c, pre) => {
    if (!c) return prefix
    const cA = c.split(' ')
    const p = pre ? `-${pre}` : ''
    return (
      cA
        // @ts-ignore
        .map(item => {
          return `${prefix}${p}-${item}`
        })
        .join(' ')
    )
  }
}

/**
 *
 * @param {*} search
 * @param {object} [opt]
 * @param {string} [opt.key]
 * @param {boolean} [opt.needDecode]
 * @returns
 */
export function getUrlParam(search, opt) {
  if (!search) return {}
  const { key, needDecode } = opt || {}
  let result = {}
  const _s = search.replace('?', '')
  const params = _s.split('&')
  for (let i = 0, len = params.length; i < len; i++) {
    const item = params[i].split('=')
    const v = needDecode ? decodeURIComponent(item[1]) : item[1]
    if (item[0] === key) {
      return v
    } else {
      // @ts-ignore
      result[item[0]] = v
    }
  }

  return result
}

/**
 * 将日期转化为年 月 日 小时 分钟 秒
 * @param {*} msec 毫秒
 * @param {string} split 分隔符
 */
export const formatFullDate = (msec, split = '') => {
  const date = new Date(msec)
  const y = date.getFullYear()
  const mon = toTen(date.getMonth() + 1)
  const day = toTen(date.getDate())
  const h = toTen(date.getHours())
  const m = toTen(date.getMinutes())
  return `${y}${split}${mon}${split}${day}  ${h}:${m}`
}

/**
 * 将日期转化为年 月 日
 * @param {number} msec 毫秒
 * @param {string} split 分隔符
 */
export const formatDate = (msec, split = '') => {
  if (msec < 1) return null
  const date = new Date(msec)
  const y = date.getFullYear()
  const mon = toTen(date.getMonth() + 1)
  const day = toTen(date.getDate())
  return `${y}${split}${mon}${split}${day}`
}

/**
 * 判断prevDay 是否是 target  的 否是前一天
 * @param {*} target
 * @param {*} prevDay
 * @returns
 */
export const isPrevDays = (target, prevDay) => {
  const c = prevDay ? new Date(prevDay).getTime() : new Date().getTime()
  const t = new Date(target)
  const dayMs = 24 * 60 * 60 * 1000
  const tzero = new Date(
    `${t.getFullYear()}/${toTen(t.getMonth() + 1)}/${toTen(t.getDate())}`,
  ).getTime()
  return c < tzero && c >= tzero - dayMs
}

/**
 * 判断是否打开小程序
 * @param {any} id
 * @returns
 */
export const isOpenMini = id => {
  //爱阅读
  return `${id}` === '7'
}

/**
 *
 * @param {any} val
 * @returns
 */
export const isObject = val => {
  return Object.prototype.toString.call(val) === '[object Object]'
}

/**
 * 将小于10的数字前面加 0
 * @param {number} num
 */
export function toTen(num) {
  return num < 10 ? `0${num}` : num
}
/**
 * 处理铜板明细
 * @param {Array<copper.RecordItem>} list
 * @returns {copper.FormatedRecordItem}
 */
export const formatCopperData = list => {
  if (!Array.isArray(list)) return { keys: [], entites: {} }

  /** @type {Array<copper.FormatedRecordItemKeys>} */
  const _list = []
  /** @type {{[key: string]: any}} */
  const entities = {}
  for (let i = 0, len = list.length; i < len; i++) {
    const { createdTime, credit } = list[i]
    const curYear = new Date().getFullYear()
    const date = new Date(createdTime)
    const y = date.getFullYear()
    const m = date.getMonth() + 1
    // const d = date.getDate()
    const key = `${curYear === y ? '' : `${y}_`}${m}`
    const keyValue = `${curYear === y ? '' : `${y}年`}${m}月`

    //存在
    if (entities[key]) {
      const _cur = entities[key]
      _cur.data.push({ ...list[i] })
      if (credit > 0) {
        _cur.awards += credit
      } else {
        _cur.expends += credit
      }
      entities[key] = {
        ..._cur,
      }
    } else {
      entities[key] = {
        awards: credit > 0 ? credit : 0,
        expends: credit < 0 ? credit : 0,
        data: [{ ...list[i] }],
      }
      _list.push({ key: key, value: keyValue })
    }
  }

  return {
    keys: _list,
    entites: { ...entities },
  }
}
